import Pagination from './Pagination'
import './Pagination.sass'

export default Pagination
